import { render, staticRenderFns } from "./InventoryViews.vue?vue&type=template&id=1cb12188&"
import script from "./InventoryViews.vue?vue&type=script&lang=ts&"
export * from "./InventoryViews.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports